import DiscoverMembershipTypes from './DiscoverMembershipTypes'

export default DiscoverMembershipTypes
